// extracted by mini-css-extract-plugin
export var button = "_1n-0";
export var buttonContent = "_1n-e";
export var buttonGroup = "_1n-c";
export var dontRestrainIconWidth = "_1n-a";
export var dropdownButton = "_1n-b";
export var iconContainer = "_1n-9";
export var lg = "_1n-4";
export var md = "_1n-3";
export var pending = "_1n-f";
export var sm = "_1n-2";
export var spinner = "_1n-d";
export var squared = "_1n-8";
export var wrapText = "_1n-g";
export var xl = "_1n-5";
export var xs = "_1n-1";
export var xxl = "_1n-6";
export var xxxl = "_1n-7";